/**
 * Extract the most recent prior auth status value from referral notes.
 *
 * Matches lines like:
 *   - "priorAuthStatus: Approved"
 *   - "priorAuthStatus: Pending Review"
 *
 * Returns the LAST occurrence to handle both Phase 1 ("Prior authorization information:" block)
 * and Phase 2 appended "PA status update:" entries.
 */
export function parsePriorAuthStatusFromNotes(notes?: string | null): string | undefined {
  if (typeof notes !== 'string' || notes.length === 0) return undefined;

  const regex = /priorauthstatus:\s*(.+)/gi;
  let lastStatus: string | undefined;

  for (const match of notes.matchAll(regex)) {
    const value = match[1]?.trim();
    if (value) {
      lastStatus = value;
    }
  }

  return lastStatus;
}
